"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleize = titleize;
exports.isTrue = isTrue;
exports.isFalse = isFalse;
exports.formatValues = formatValues;
exports.isGlobalParam = isGlobalParam;
exports.parseOSC = parseOSC;
exports.isParamGroup = isParamGroup;
exports.formatParamSendName = formatParamSendName;
exports.reduceParamObject = reduceParamObject;
exports.reduceParamArray = reduceParamArray;
exports.buildMessage = buildMessage;
exports.formatFloat = formatFloat;
exports.pollPort = pollPort;
exports.isSecondaryConnect = isSecondaryConnect;
exports.isReconnect = isReconnect;
exports.isDisconnect = isDisconnect;
exports.isWindows = isWindows;
exports.isWindows10 = isWindows10;
exports.isLinux = isLinux;
exports.isValidPort = isValidPort;

var _lodash = _interopRequireDefault(require("lodash.pick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function titleize(string) {
  return string.toLowerCase().replace(/\b\w/g, m => m.toUpperCase());
}

function isTrue(subject) {
  return subject === true;
}

function isFalse(subject) {
  return subject === false;
}

function formatValues(values) {
  return String(values).split(',').map(value => {
    return window.isNaN(value) ? value.trim() : Number(value);
  });
}

function isGlobalParam(param) {
  return ['barGain', 'barGains', 'barAvgLow', 'barAvgHigh', 'barAvgLows', 'barAvgHighs', 'barLowMult', 'barLowMults', 'barHighMult', 'barHighMults', 'barDownThresholds', 'barUpThresholds', 'barDownThreshold', 'barUpThreshold', 'buttonPresetMode', 'crosstalkTimeWindow', 'crosstalkVelocityScale', 'negativeVelocityOffset', 'negativeVelocityOffsets', 'calibrationGain', 'thresholdMult'].includes(param);
}

function parseOSC(message) {
  let {
    address: param,
    args: values
  } = (0, _lodash.default)(message, ['address', 'args']);
  param = cleanAddress(param);
  return {
    param: param,
    values: values
  };
}

function isParamGroup(param) {
  return ['button', 'split', 'fader', 'pedal', 'gapCaps', 'playParams'].includes(param);
}

function cleanAddress(address) {
  const heads = ['/p/w/', '/g/w/', '/fw/w/', '/uc/', '/p/', '/cb/']; // TODO: use regex
  // /(\/(uc|fw|g|p|w)?)+/g

  let cleaned = '';

  if (address.includes(heads[0])) {
    cleaned = address.replace(heads[0], '');
  } else if (address.includes(heads[1])) {
    cleaned = address.replace(heads[1], '');
  } else if (address.includes(heads[2])) {
    cleaned = address.replace(heads[2], '');
  } else if (address.includes(heads[3])) {
    cleaned = 'usercurve';
  } else if (address.includes(heads[4])) {
    cleaned = address.replace(heads[4], '');
  } else if (address.includes(heads[5])) {
    cleaned = 'calibration';
  } else {
    cleaned = address;
  }

  return cleaned;
}

function formatParamSendName(name) {
  return specialParamList.includes(name) ? name.substring(0, name.length - 1) : name;
}

const specialParamList = ['splits', 'faders', 'buttons', 'pedals'];

function reduceParamObject(param, index = null) {
  return Object.keys(param).reduce((messageArr, key) => {
    messageArr.push(param[key].toString());
    return messageArr;
  }, index != null ? [index] : []).toString();
}

function reduceParamArray(param, index) {
  return reduceParamObject(param[index], index);
}

function buildMessage(difference, preset) {
  const diffKey = Object.keys(difference).toString(),
        diffValue = difference[diffKey];
  let messagePayload = '';

  if (isPlainObject(diffValue)) {
    // nested
    if (diffKey === 'gapCaps' || diffKey === 'playParams') {
      messagePayload = Object.keys(preset[diffKey]).reduce((arr, key) => {
        arr.push(preset[diffKey][key]);
        return arr;
      }, []).toString();
      return [formatParamSendName(diffKey), messagePayload];
    } else {
      const index = Object.keys(difference[diffKey]);
      messagePayload = Object.keys(preset[diffKey][~~index]).reduce((arr, key) => {
        arr.push(preset[diffKey][~~index][key]);
        return arr;
      }, []);
      return [formatParamSendName(diffKey), index.concat(messagePayload).toString()];
    }
  } else {
    // single param
    messagePayload = difference[diffKey];
    return [formatParamSendName(diffKey), messagePayload.toString()];
  }
}

function formatFloat(value) {
  let fv = parseFloat(value);

  if (fv - Math.floor(fv) === 0) {
    return fv + 0.0001;
  } else {
    return fv;
  }
}

function pollPort(device, port, type, doesExist = true) {
  console.log('>> malletStation: searching for', port, type, 'until', doesExist ? 'connected' : 'disconnected');
  return new Promise((accept, reject) => {
    let foundPort,
        poll = window.setInterval(() => {
      foundPort = device._ports[`get${titleize(type)}`](port, false);

      if (foundPort) {
        clearInterval(poll);
        accept(foundPort);
      }
    }, 250);
  });
}
/**
 * Returns promise from event
 * @function
 * @param {String} event name
 * @returns {Promise}
 */


function promiseEvent(device, event) {
  return new Promise(function (resolve) {
    device.once(event, resolve);
  });
}

; // MIDI connections

function isSecondaryConnect(connections) {
  const {
    input,
    output
  } = connections;
  return !input.initial && !output.initial && input.connected && output.connected;
}

function isReconnect(connections) {
  const {
    input,
    output
  } = connections;
  return input.previous && output.previous && input.connected && output.connected;
}

function isDisconnect(connections) {
  const {
    input,
    output
  } = connections;
  return !input.connected && !output.connected;
}

function isWindows() {
  if (typeof process !== "undefined" && process.platform === 'win32') {
    return true;
  } else {
    return window.navigator && window.navigator.platform && window.navigator.platform.indexOf('Win') >= 0;
  }
}

function isWindows10() {
  return isWindows() && /Windows\s*\w*\s*10/g.test(window.navigator.platform);
}

function isLinux() {
  if (typeof process !== "undefined" && process.platform === 'linux') {
    return true;
  } else {
    return window.navigator && window.navigator.platform && window.navigator.platform.indexOf('Linux') >= 0;
  }
} // ignore non malletStation ports, Expander port


function isValidPort(name, bootloader = true) {
  if (name.includes('Expander')) {
    return false;
  } else if (name.includes('malletStation Bootloader')) {
    return bootloader ? true : false;
  } else if (isWindows()) {
    return name.includes('malletStation') && !name.includes('MIDI');
  } else if (isLinux()) {
    return name.includes('malletStation') && name.includes('MIDI 1');
  } else {
    return name.includes('malletStation') && !bootloader;
  }
}